<template>
    <div class="guangfu-tongyi">
        <div class="con">
             <div class="tab-top">
                    <div class="left-p">
                        <p :class="{'active':nowCheck == 0}" @click="nowCheck = 0" title="全部">全部</p>
			         	<p :class="{'active':nowCheck == 1}" @click="nowCheck = 1" title="正常">正常</p>
			         	<p :class="{'active':nowCheck == 2}" @click="nowCheck = 2" title="告警">告警</p>
			         	<p :class="{'active':nowCheck == 3}" @click="nowCheck = 3" title="离线">离线</p>
			         	<p :class="{'active':nowCheck == 4}" @click="nowCheck = 4" title="停机">停机</p>
                    </div>
                    <div class="btns">
                           <!-- <el-button type="primary"  class="last-el-button"></el-button> -->
					</div>
              </div>
              <div class="my-list">
                  <div class="list-item">
                    <div class="item-top">
                         <div class="img-left">
                            <img src="../../assets/unifyImg/box.png" alt="">
                         </div>
                         <div class="right-name">
                             <div class="names">
                                <p>箱变TY1-1 <span>(额定功率：110KW)</span></p>
                                <div class="zhaungtai">正常</div>
                             </div>
                             <div class="btns">运行参数</div>

                         </div>
                    </div>
                    <div class="canshu">
                        <div class="canshu-left">
                            <div class="names">
                               <span>实时参数</span>
                               <span class="spoan2">额定电压：12KV</span>
                            </div>
                            
                        </div>
                       <div class="canshu-bo">
                         <div class="ele-left">
                             <div class="canshu-item">
                                <span>电流</span>
                                <span>630A</span>
                             </div>
                             <div class="canshu-item">
                                <span>频率</span>
                                <span>50HZ</span>
                             </div>
                        </div>
                        <div class="ele-right">
                             <div class="canshu-item">
                                <span>开断电流</span>
                                <span>630A</span>
                             </div>
                             <div class="canshu-item">
                                <span>动稳定电流</span>
                                <span>40KA</span>
                             </div>
                        </div>
                       </div>
                    </div>

                  </div>
                   <div class="list-item">
                    <div class="item-top">
                         <div class="img-left">
                            <img src="../../assets/unifyImg/box.png" alt="">
                         </div>
                         <div class="right-name">
                             <div class="names">
                                <p>箱变ST-10 <span>(额定功率：110KW)</span></p>
                                <div class="zhaungtai">正常</div>
                             </div>
                             <div class="btns">运行参数</div>

                         </div>
                    </div>
                    <div class="canshu">
                        <div class="canshu-left">
                            <div class="names">
                               <span>实时参数</span>
                               <span class="spoan2">额定电压：12KV</span>
                            </div>
                            
                        </div>
                       <div class="canshu-bo">
                         <div class="ele-left">
                             <div class="canshu-item">
                                <span>电流</span>
                                <span>630A</span>
                             </div>
                             <div class="canshu-item">
                                <span>频率</span>
                                <span>50HZ</span>
                             </div>
                        </div>
                        <div class="ele-right">
                             <div class="canshu-item">
                                <span>开断电流</span>
                                <span>630A</span>
                             </div>
                             <div class="canshu-item">
                                <span>动稳定电流</span>
                                <span>40KA</span>
                             </div>
                        </div>
                       </div>
                    </div>

                  </div>
                   <div class="list-item">
                    <div class="item-top">
                         <div class="img-left">
                            <img src="../../assets/unifyImg/box.png" alt="">
                         </div>
                         <div class="right-name">
                             <div class="names">
                                <p>箱变ZP2-8 <span>(额定功率：110KW)</span></p>
                                <div class="zhaungtai">正常</div>
                             </div>
                             <div class="btns">运行参数</div>

                         </div>
                    </div>
                    <div class="canshu">
                        <div class="canshu-left">
                            <div class="names">
                               <span>实时参数</span>
                               <span class="spoan2">额定电压：12KV</span>
                            </div>
                            
                        </div>
                       <div class="canshu-bo">
                         <div class="ele-left">
                             <div class="canshu-item">
                                <span>电流</span>
                                <span>630A</span>
                             </div>
                             <div class="canshu-item">
                                <span>频率</span>
                                <span>50HZ</span>
                             </div>
                        </div>
                        <div class="ele-right">
                             <div class="canshu-item">
                                <span>开断电流</span>
                                <span>630A</span>
                             </div>
                             <div class="canshu-item">
                                <span>动稳定电流</span>
                                <span>40KA</span>
                             </div>
                        </div>
                       </div>
                    </div>

                  </div>
              </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'WedoWebInverter',

    data() {
        return {
            nowCheck:0
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
};
</script>

<style lang="scss" scoped>
.tab-top {
            display: flex;
            justify-content: space-between;
            box-sizing: border-box;
             height: 42px;
            border-bottom: 2px solid #e6e6e6;
            .left-p {
                display: flex;
                font-size: 16px;
                color: #666;
                height: 42px;
               p {
                 margin-right: 20px;
                 margin-top: 5px;
                 &.active {
                    color: #368ED9;
                    border-bottom: 2px solid #368ED9;
                 }
               }
            }
        }
        .my-list {
            display: flex;
        }
        .list-item {
            width: 500px;
            height: 280px;
            background-color: #fff;
            border: 1px solid #e6e6e6;
            border-radius: 4px;
            margin-top: 20px;
            margin-right: 15px;
             padding: 12px 20px;
               box-sizing: border-box;
            .item-top {
                width: 100%;
                height: 130px;
               
              
                display: flex;

                img {
                    width: 110px;
                    height:120px;
                    margin-right: 20px;
                }
                .right-name {
                     width: 100%;
                    .names {
                        width: 100%;
                        display: flex;
                        justify-content: space-between;
                       
                        p {
                            font-size: 16px;
                            span {
                                font-size: 14px;
                                color: #999999;
                            }
                        }

                    }
                    .zhaungtai {
                        width: 70px;
                        height: 25px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background-color: #edf8ec;
                        color: #70b66f;
                        border-radius: 35px;
                    }
                    .btns {
                        margin-top: 10px;
                        width: 100px;
                        height: 30px;
                        border-radius: 60px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 14px;
                        color: #368ed9;
                        border: 1px solid #368ed9;
                    }
                }
            }
            .canshu {
                width: 100%;
                height: 110px;
                background-color: #f7f8fc;
                border-radius: 4px;
                padding: 20px 12px;
                box-sizing: border-box;
                .canshu-left {
                     .names {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        .spoan2 {
                            font-size: 13px;
                            color: #999;
                        }
                     }
                }
                .canshu-bo {
                    width: 100%;
                    display: flex;
                }
                .ele-left{
                    width: 50%;

                }
                .canshu-item {
                    border-right: 1px solid #999;
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-top: 10px;
                    padding-right: 15px;
                    box-sizing: border-box;
                    color: #999;
                }
                .ele-right{
                    width: 50%;
                    .canshu-item {
                        padding-left: 15px;
                        border: 0px;
                    }
                }
                
            }
        }
</style>